module.exports = __webpack_public_path__ + "media/snowswipetwo.78bc59aa.mp3";